<template>
  <li>
    <span>{{ this.labelname }}</span>
    <span>
      <input
        :type="fieldtype"
        v-if="edit"
        v-model="valueLocal"
        @blur="blurMethod('blur')"
        @keyup.enter="enterMethod('enter')"
        @keyup.esc="escMethod('esc')"
        v-focus=""
      />

      <span v-else-if="this.fieldtype == 'text'">
        {{ valueLocal }}
        <transition name="fade">
          <div class="email_error" v-if="has_email_error">
            <small>{{ email_error }}</small>
            <i class="vue-anchor dismiss gray" @click="clear"><sup>[X]</sup></i>
          </div>
        </transition>
      </span>
      <span v-else>*********************</span>
    </span>
    <span>
      <a class="vue-anchor" @click="editClick()">
        <span class="icon-edit"></span>
        Edit
      </a>
    </span>
  </li>
</template>

<script>
  export default {
    props: {
      labelname: {
        type: String,
        default: 'Label',
      },
      fieldtype: {
        type: String,
        default: 'text',
      },
      fieldname: {
        type: String,
        default: 'fieldname',
      },
      propvalue: {
        type: String,
        default: '',
      },
      _token: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        edit: false,
        valueLocal: this.propvalue,
        valueOriginal: this.propvalue,
        edit: false,
        isblur: 0,
        value: this.propvalue,
        has_email_error: false,
        email_error: null,
      };
    },

    watch: {
      value: function () {
        this.valueLocal = this.value;
      },
    },

    directives: {
      focus: {
        inserted(el) {
          el.focus();
        },
      },
    },

    methods: {
      clear() {
        this.has_email_error = false;
        this.email_error = null;
      },
      editClick: function () {
        this.valueOriginal = this.value;

        this.edit = true;
        this.isblur = 0;
      },

      blurMethod: function (type) {
        if (this.isblur === 0) {
          switch (type) {
            case 'blur':
              this.update();

              //then run update

              break;

            case 'enter':
              this.update();
              this.isblur = 1;
              this.edit = false; //this triggers blur again which is why we have the isblur check

              break;

            case 'esc':
              this.valueLocal = this.valueOriginal;
              this.isblur = 1;
              this.edit = false; //this triggers blur again which is why we have the isblur check

              break;

            default:
              this.isblur = 1;
              this.edit = false;
          } //end case
          return;
        } else {
          return;
        } //end if
      },
      update: function () {
        this.has_email_error = false;
        this.email_error = null;
        //check if value has changed
        if (this.valueLocal === this.valueOriginal) {
          //if (false) {
          this.edit = false; //this triggers blur again which is why we have the isblur check
        } else {
          //run axios post for validation

          //then run update
          axios
            .post('/user/update/userinfo', {
              _token: this._token,
              fieldname: this.fieldname,
              value: this.valueLocal,
            })
            .then((success) => {
              if (!success.data.success) {
                this.has_email_error = true;
                this.email_error = success.data.data.email[0];
                this.valueLocal = this.valueOriginal;
              }
              this.isblur = 1;
              this.edit = false; //this triggers blur again which is why we have the isblur check
            })
            .catch(function (error) {
              // TODO: HANDLE ERROR - This is just silencing the error
            });
        } //end if valuelocal == value original do nothing
      },
      enterMethod: function (type) {
        this.blurMethod(type);
      },
      escMethod: function (type) {
        this.blurMethod(type);
      },
    }, //end methods
  }; //end export defaults
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
